import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes as RouterRoutes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import ScrollToTop from "components/ScrollToTop";
import Header from "components/ui/Header";
import NotFound from "pages/NotFound";
import ContactSupport from "./pages/contact-support";
import AboutUs from "./pages/about-us";
import Homepage from "./pages/homepage";

import AdminPage from "./admin/AdminPage";
import ProductDashboard from "./admin/ProductDashboard";
import PageLoader from "components/ui/PageLoader";
import WhatsAppButton from "components/ui/WhatsAppButton";

// =============================
// Layout Wrapper
// =============================
const Layout = ({ children }) => {
  const location = useLocation();

  const isAdminRoute =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/admin/dashboard");

  return (
    <>
      <ScrollToTop />
      {!isAdminRoute && <Header />}

      {children}

      {!isAdminRoute && <WhatsAppButton />}
    </>
  );
};

// =============================
// Route Loader Animation
// =============================
const RouteChangeLoader = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <>
      {loading && <PageLoader />}
      {children}
    </>
  );
};

// =============================
// MAIN ROUTES
// =============================
const Routes = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  // Sync state with localStorage
  useEffect(() => {
    const stored = localStorage.getItem("isAdmin") === "true";
    setLoggedIn(stored);
  }, []);

  const handleLogin = () => {
    setLoggedIn(true);
    localStorage.setItem("isAdmin", "true");
  };

  const handleLogout = () => {
    setLoggedIn(false);
    localStorage.removeItem("isAdmin");
  };

  return (
    <BrowserRouter>
      <Layout>
        <RouteChangeLoader>
          <RouterRoutes>
            {/* Public Routes */}
            <Route path="/" element={<Homepage />} />
            <Route path="/contact" element={<ContactSupport />} />
            <Route path="/about-us" element={<AboutUs />} />

            

            

            {/* Admin */}
            <Route
              path="/admin"
              element={<AdminPage onLogin={handleLogin} />}
            />
            <Route
              path="/admin/dashboard"
              element={
                loggedIn ? (
                  <ProductDashboard onLogout={handleLogout} />
                ) : (
                  <Navigate to="/admin" replace />
                )
              }
            />

            {/* Not Found */}
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </RouteChangeLoader>
      </Layout>
    </BrowserRouter>
  );
};

export default Routes;
